import React from "react";
import { PageWrapper } from "~components/Core";
import TermsConditionSection from "~sections/utility/TermsCondition"
import FooterTwo from '~sections/project/FooterTwo'
import HeaderButton from '~sections/project/Header'

const header = {
    headerClasses: "site-header site-header--menu-start light-header site-header--sticky",
    containerFluid:true,
    buttonBlock: (
      <HeaderButton
        className="ms-auto d-none d-xs-inline-flex"
        btnOneText="Login"
        btnTwoText="Sign up for early access"
        mr="15px"
        mrLG="0"
      />
    ),
  }

export default function TermsAndConditions() {
  return (
    <PageWrapper headerConfig={header}>
        <TermsConditionSection/>
        <FooterTwo/>
    </PageWrapper>
  )
}
